import {
  Button,
  Div,
  H3,
  LocationEntity,
  Modal,
  ModalIconStyle,
  P,
  PropsModal,
  RecoverIcon,
  SuccessToast,
  recoverLocationById,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const LocationRecoverModal = ({
  setLoading,
  modalIsOpen,
  closeModal,
  onSuccess,
}: PropsModal & {
  setLoading: Dispatch<SetStateAction<boolean>>;
  modalIsOpen: LocationEntity | null;
  onSuccess?: () => void;
}) => {
  const location = modalIsOpen;

  async function handleRecoverLocation() {
    if (!location) return;
    try {
      setLoading(true);
      const { data } = await recoverLocationById(location.id);
      SuccessToast(data.message);
      onSuccess?.();
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      zIndex={111}
    >
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <RecoverIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Recover Location?</H3>
      <P $mb="0">Are you sure tou want to recover this location?</P>

      <Div $flex $gap="8px" $column $mt="32">
        <Button $selected $w="100%" onClick={handleRecoverLocation}>
          Recover Location
        </Button>
        <Button $selected $gray $w="100%" onClick={() => closeModal?.()}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
